import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=5a5c5161&scoped=true"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=5a5c5161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c5161",
  null
  
)

export default component.exports